import { licenseInviteLinkModalActionTypes } from './Constants';

export function toggleLicenseInviteLinkModal(data) {
	return {
		type: licenseInviteLinkModalActionTypes.TOGGLE_LICENSE_INVITE_LINK_MODAL,
		payload: { data },
	};
}

export function getLicenseInviteLink(id) {
	return {
		type: licenseInviteLinkModalActionTypes.GET_LICENSE_INVITE_LINK,
		payload: { id },
	};
}

export function getLicenseInviteLinkSuccess(data) {
	return {
		type: licenseInviteLinkModalActionTypes.GET_LICENSE_INVITE_LINK_SUCCESS,
		payload: { data },
	};
}

export function getLicenseInviteLinkError() {
	return {
		type: licenseInviteLinkModalActionTypes.GET_LICENSE_INVITE_LINK_ERROR,
	};
}

export function clearState() {
	return {
		type: licenseInviteLinkModalActionTypes.CLEAR_LICENSE_INVITE_LINK_MODAL_STATE,
	};
}
